import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface WalletHeroConfig {
  enabled: boolean;
  mode: 'all' | 'countries';
  countries: string[];
}

export const useWalletHeroConfig = () => {
  const [showWalletHero, setShowWalletHero] = useState(false);
  const [config, setConfig] = useState<WalletHeroConfig | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await supabase.functions.invoke('admin', {
          body: { action: 'get_wallet_hero_config' }
        });

        if (response.data?.success) {
          setShowWalletHero(response.data.show_wallet_hero === true);
          setConfig(response.data.config);
        }
      } catch (error) {
        console.error('Failed to fetch wallet hero config:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return { showWalletHero, config, isLoading };
};
